import {WorkspaceViewId,WorkspaceViewModel} from './workspaceViews';
import './WorkspaceViewSwitch.css';

type Props={model:WorkspaceViewModel;activeView:WorkspaceViewId|null;onSelect:(view:WorkspaceViewId)=>void};

export function WorkspaceViewSwitch({model,activeView,onSelect}:Props){
  if(model.views.length===0)return null;
  const allowed=new Set(model.views.map(view=>view.id));
  const selected=activeView!==null&&allowed.has(activeView)?activeView:model.defaultView;
  return <nav className="workspace-view-switch" aria-label="Workspace views">
    {model.views.map(view=><button
      aria-current={view.id===selected?'page':undefined}
      className="workspace-view-switch__choice"
      key={view.id}
      onClick={()=>onSelect(view.id)}
      type="button"
    >{view.label}</button>)}
  </nav>;
}
